export const translations = {
    es: {
        // Títulos
        "no.measures": "No hay datos de Medidas en este rango de fechas",
        "no.battery": "No hay datos de Batería en este rango de fechas",
        "no.temperature": "No hay datos de Temperatura en este rango de fechas",
        "no.devices": "No se encuentran dispositivos asociados a este contenedor",
    },
    en: {
        // Títulos
        "no.measures": "No Measures data available in this date range",
        "no.battery": "No Battery data available in this date range",
        "no.temperature": "No Temperature data available in this date range",
        "no.devices": "No Devices data available in this date range",
    },
};
